import { apiRequest } from "../util/apiUtils";

export const profileDetails = async () => {
  try {
    const res = await apiRequest("get", `profile`);
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const profileUpdate = async (params) => {
  try {
    const res = await apiRequest(
      "put",
      `profile/edit`,
      {
        body: {
          ...params,
        },
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const publicProfileUpdate = async (params) => {
  try {
    const res = await apiRequest(
      "post",
      `user/artist/manage`,
      {
        body: {
          ...params,
        },
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const publicProfileDetails = async (params) => {
  try {
    const res = await apiRequest(
      "get",
      `user/artist/detail`,
      {
        queries: {
          ...params,
        },
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const changePassword = async (params) => {
  try {
    const res = await apiRequest("patch", `profile/change-password`, {
      body: {
        ...params,
      },
    });
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const sendOtp = async (params) => {
  try {
    const res = await apiRequest(
      `${"post"}`,
      `${"/send-otp"}`,
      {
        body: {
          ...params,
        },
      }
      // "multipart/form-data"
    );
    const data = res.data;
    return res;
  } catch (err) {
    return err;
  }
};

export const verifyOtp = async (params) => {
  try {
    const res = await apiRequest(
      `${"post"}`,
      `${"/verify-otp"}`,
      {
        body: {
          ...params,
        },
      }
      // "multipart/form-data"
    );
    const data = res.data;
    return res;
  } catch (err) {
    return err;
  }
};

export const forgotPassword = async (params) => {
  try {
    const res = await apiRequest(
      `${"post"}`,
      `${"/forget-password"}`,
      {
        body: {
          ...params,
        },
      }
      // "multipart/form-data"
    );
    const data = res.data;
    return res;
  } catch (err) {
    return err;
  }
};

export const getVerifyToken = async (params) => {
  try {
    const res = await apiRequest("post", "verify-token", {});
    return res;
  } catch (error) {
    return error;
  }
};

export const changeEmail = async (params) => {
  try {
    const res = await apiRequest(
      `${"put"}`,
      `${"/profile/change-email"}`,
      {
        body: {
          ...params,
        },
      }
      // "multipart/form-data"
    );
    const data = res.data;
    return data;
  } catch (err) {
    return err;
  }
};

export const profileImageDelete = async () => {
  try {
    const res = await apiRequest("delete", `profile/delete/image`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};
